import { render, staticRenderFns } from "./blog-article.vue?vue&type=template&id=eb165d6c&scoped=true"
import script from "./blog-article.vue?vue&type=script&lang=js"
export * from "./blog-article.vue?vue&type=script&lang=js"
import style0 from "./blog-article.vue?vue&type=style&index=0&id=eb165d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb165d6c",
  null
  
)

export default component.exports